import { ServingContent, ServingPill } from "@thrivetribe/mvf.ui.molecules.serving-content";
import { RecipeType } from "types";
import React from 'react';

const mapLightToColor = (color: string | undefined) => {
  const colorMap: any = {
    green: "#2AC563",
    orange: "#FE9330",
    red: "#ED0000",
    grey: "#DEDEDA",
  };

  if (color) {
    return colorMap[color] ?? colorMap.grey;
  }

  return colorMap.grey;
};


export const WhatIsInAServing = ({ recipe }: {recipe?: RecipeType}) => {
  const mealParams: any = {};
  const mealType = recipe?.mealType[0];
  if (mealType) {
    mealParams[mealType.toLowerCase()] = 2;
  }

  return (
    <div className="recipe__portions--servingcontent">
      <ServingContent>
        <ServingPill
          percentage={recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.energyKj.percentRi}
          color={mapLightToColor(recipe?.nutritionalBreakdown?.per100gFoodLabel.energyKj.trafficLight)}
          title={"Energy"}
          energyKcal={Number(recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.energyKcal.weight)}
          energyKj={Number(recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.energyKj.weight)}
        />
        <ServingPill
          percentage={recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.fat.percentRi}
          color={mapLightToColor(recipe?.nutritionalBreakdown?.per100gFoodLabel.fat.trafficLight)}
          title={"Fat"}
          energyGram={Number(recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.fat.weight)}
        />
        <ServingPill
          percentage={recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.satFat.percentRi}
          color={mapLightToColor(recipe?.nutritionalBreakdown?.per100gFoodLabel.satFat.trafficLight)}
          title={"Saturates"}
          energyGram={Number(recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.satFat.weight)}
        />
        <ServingPill
          percentage={recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.sugars.percentRi}
          color={mapLightToColor(recipe?.nutritionalBreakdown?.per100gFoodLabel.sugars.trafficLight)}
          title={"Sugars"}
          energyGram={Number(recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.sugars.weight)}
        />
        <ServingPill
          percentage={recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.salt.percentRi}
          color={mapLightToColor(recipe?.nutritionalBreakdown?.per100gFoodLabel.salt.trafficLight)}
          title={"Salts"}
          energyGram={Number(recipe?.nutritionalBreakdown?.portion?.singleServing.foodLabel.salt.weight)}
        />
      </ServingContent>
    </div>
  );
};
